import { render, staticRenderFns } from "./FraudCommentsView.vue?vue&type=template&id=5e5213df&scoped=true&"
import script from "./FraudCommentsView.vue?vue&type=script&lang=js&"
export * from "./FraudCommentsView.vue?vue&type=script&lang=js&"
import style0 from "./FraudCommentsView.vue?vue&type=style&index=0&id=5e5213df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5213df",
  null
  
)

export default component.exports